const MED_BANNER_LS_ID = 'med-banner-close-timestamp';
const MED_BANNER_CLOSE_TIMEOUT = 6 * 30 * 24 * 60 * 60 * 1000; // 6 month

function getMedBannerCloseTimestamp() {
  const lsTimestampValue = localStorage.getItem(MED_BANNER_LS_ID);
  return lsTimestampValue === null ? 0 : Number(lsTimestampValue);
}

export function closeMedBanner() {
  // write timestamp to close value
  const lsTimestampValue = `${Date.now()}`;
  localStorage.setItem(MED_BANNER_LS_ID, lsTimestampValue);
}

export function canBannerBeShown() {
  const now = Date.now();
  const closeTimestamp = getMedBannerCloseTimestamp();
  const closeCondition = closeTimestamp !== 0 ? now - closeTimestamp >= MED_BANNER_CLOSE_TIMEOUT : true;
  return closeCondition;
}
